import {
    SET_ADMIN_TASK_GRID_VALUES, 
    SET_ATTACHMENTS_LIST, 
    SET_INITIAL_TASK_DETAIL, 
    SET_LINKED_ATTACHMENTS, 
    SET_FLEET_PROCESSING_ITEM_STATUS_LIST, 
    SET_RECEVING_COSTCENTER_OPTION,
    SET_UPDATE_REASON_CODE_RESPONSE,
    SET_ORDER_HEADER_DETAILS,
    SET_FLEET_ITEM_HEADER_DETAILS,
    SET_FLEET_ITEM_DETAILS,
    SET_FLEET_ITEM_PURCHASE_DETAILS,
    SET_FLEET_ITEM_PURCHASE_ORDER,
    SET_FLEET_ITEM_VENDOR_DETAILS,
    SET_FLEET_ITEM_TASK_DETAILS,
    SET_FLEET_ITEM_PURCHASE_DETAILS_SAVE,
    SET_FLEET_ITEM_PURCHASE_ORDER_SAVE,
    SET_FLEET_ITEM_VENDOR_DETAILS_SAVE,
    SET_COMMENT_SAVED,
    SET_IS_ITEM_DETAILS_SAVED,
    SET_ITEM_ATTACHMENTS_LINKED_SAVED,
    IS_MULTIPLE_POD_SAVED,
    IS_MULTIPLE_DEALER_VENDOR_SAVED,
    IS_MULTIPLE_PO_DETAILS_SAVED,
    IS_CONSOLIDATED_FLAG_SAVED,
    IS_ORDER_ATTACHMENTS_SAVED,
    SET_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_OPEN_ACCORDION_LIST,
    SET_VIN_VALIDATION_RESULT,
    SET_CATALOG_OVERRIDE_SAVED
} from "./FleetManagementType"

const initialState = {
    adminTaskGridValues: [],
    initialTaskDetail: {},
    attachmentList: [],
    receivingCostCenterOption: [],
    itemStatusList: [],
    openAccordionList: [],
    vinValidationResult: null,
    catalogOverrideSaved: null
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ADMIN_TASK_GRID_VALUES:
            return {
                ...state,
                adminTaskGridValues: action.adminTaskGridValues
            };
        case SET_INITIAL_TASK_DETAIL:
            return {
                ...state,
                initialTaskDetail: action.initialTaskDetail
            }
        case SET_ATTACHMENTS_LIST: return {
            ...state,
            attachmentList: action.attachmentList
        }
        case SET_LINKED_ATTACHMENTS:
            return {
                ...state,
                linkedAttachments: action.linkedAttachments
            }
        case SET_RECEVING_COSTCENTER_OPTION:
            return{
                ...state,
                receivingCostCenterOption : action.receivingCostCenterOption
            }    
        case SET_FLEET_PROCESSING_ITEM_STATUS_LIST:
            return {
                ...state,
                itemStatusList: action.itemStatusList
            }
        case SET_UPDATE_REASON_CODE_RESPONSE:
            return {
                ...state,
                updateReasonCodeResponse: action.payload
            };
        case SET_ORDER_HEADER_DETAILS:
            return {
                ...state,
                orderHeaderDetails: action.value,
            };        
        case SET_FLEET_ITEM_HEADER_DETAILS:
            return {
                ...state,
                fleetItemHeaderDetails: action.value,
            };        
        case SET_FLEET_ITEM_DETAILS:
            return {
                ...state,
                fleetItemDetails: action.value,
            };        
        case SET_FLEET_ITEM_PURCHASE_DETAILS:
            return {
                ...state,
                fleetItemPurchaseDetails: action.value,
            };        
        case SET_FLEET_ITEM_PURCHASE_ORDER:
            return {
                ...state,
                fleetItemPurchaseOrder: action.value,
            };
        case SET_FLEET_ITEM_VENDOR_DETAILS:
            return {
                ...state,
                fleetItemVendorDetails: action.fleetItemVendorDetails,
            };
        case SET_FLEET_ITEM_TASK_DETAILS:
            return {
                ...state,
                fleetItemTaskDetails: action.fleetItemTaskDetails,
            };
        case SET_FLEET_ITEM_PURCHASE_DETAILS_SAVE:
            return {
                ...state,
                fleetItemPurchaseDetailsSave: action.fleetItemPurchaseDetailsSave,
            };
        case SET_FLEET_ITEM_PURCHASE_ORDER_SAVE:
            return {
                ...state,
                fleetItemPurchaseOrderSave: action.fleetItemPurchaseOrderSave,
            };
        case SET_FLEET_ITEM_VENDOR_DETAILS_SAVE:
            return {
                ...state,
                fleetItemVendorDetailsSave: action.fleetItemVendorDetailsSave,
            };        
        case SET_COMMENT_SAVED:
            return {
                ...state,
                isCommentSaved: action.value,
            };        
        case SET_IS_ITEM_DETAILS_SAVED:
            return {
                ...state,
                isItemSaved: action.value,
            };        
        case SET_ITEM_ATTACHMENTS_LINKED_SAVED:
            return {
                ...state,
                isItemAttachmentsSaved: action.value,
            };        
        case IS_MULTIPLE_POD_SAVED:
            return {
                ...state,
                isMultiPODSaved: action.value,
            };        
        case IS_MULTIPLE_DEALER_VENDOR_SAVED:
            return {
                ...state,
                isMultiDealerSaved: action.value,
            };        
        case IS_MULTIPLE_PO_DETAILS_SAVED:
            return {
                ...state,
                isMultiPurchaseOrdersaved: action.value,
            };        
        case IS_CONSOLIDATED_FLAG_SAVED:
            return {
                ...state,
                isConsolidatedFlagSaved: action.value,
            };
        case IS_ORDER_ATTACHMENTS_SAVED:
            return {
                ...state,
                isOrderAttachmentsSaved: action.flag,
            };  
        case SET_ASSIGNED_TO_FOR_ALL_ITEM:
            return {
                ...state,
                assignedForAllItem: action.assignedForAllItem
            };
        case SET_OPEN_ACCORDION_LIST:
            return {
                ...state,
                openAccordionList: action.list
            };
        case SET_VIN_VALIDATION_RESULT:
            return {
                ...state,
                vinValidationResult: action.validationResult
            };
        case SET_CATALOG_OVERRIDE_SAVED:
            return {
                ...state,
                catalogOverrideSaved: action.catalogOverrideSaved
            };
        default:
            return state;
    }
};

export default reducer;